import React from 'react';

import PropTypes from 'prop-types';
import DimpleDivider from '@tds/core-dimple-divider';
import Heading from '@tds/core-heading';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import FilesListRow from './filesListRow';

const FilesList = ({ filesList, removeFileFromList, orderId }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    general: { fileListLabel }
  } = localizedStrings;

  return (
    <>
      <DimpleDivider />
      <div className="card">
        <div className="card-header">
          <Heading level="h4">{fileListLabel}</Heading>
        </div>
        <ul className="list-group list-group-flush">
          {filesList.map(file => (
            <FilesListRow
              key={file.fileId}
              orderId={orderId}
              fileData={file}
              removeFileFromList={removeFileFromList}
            />
          ))}
        </ul>
      </div>
    </>
  );
};

FilesList.propTypes = {
  filesList: PropTypes.arrayOf(PropTypes.object).isRequired,
  removeFileFromList: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired
};

export default FilesList;
